<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <div class="row" :class="errorMessage ? 'is-invalid' : ''">
      <div class="col-auto">
        <input type="text" class="form-control" maxlength="7" v-model="value" :class="errorMessage ? 'is-invalid' : ''">
      </div>
      <div class="col d-flex align-items-center">
        <base-button class="btn-sm btn-light border-dark" text="住所自動入力" @click="setAddress" />
      </div>
    </div>
    <div class="invalid-feedback">{{ errorMessage }}</div>
    <span class="p-country-name" style="display:none;">Japan</span>
  </form-layout>
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem'
import FormLayout from '@/views/templates/FormLayout'
import BaseButton from '@/views/atoms/BaseButton'

export default {
  name: "VuexPostalCodeFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: false,
      default: '郵便番号'
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    bind: {
      type: String,
      default: 'postal_code'
    },
    bindPrefectureCode: {
      type: String,
      default: 'prefecture_code'
    },
    bindAddress: {
      type: String,
      default: 'address1'
    },
  },
  components: {
    FormLayout,
    BaseButton,
  },
  methods: {
    setAddress() {
      new window.YubinBangoCore(this.value, (address) => {
        if (!address.region_id && !(address.locality + address.street)){
          this.$store.commit('setFlashMessage', {value: '入力された郵便番号から住所情報が取得できませんでした'}, {root: true});
          this.$root.showFlashMessage();
        }

        this._commit(this.bindPrefectureCode, address.region_id || null);
        this._commit(this.bindAddress, address.locality + address.street || null);
      })
    },
  }
}
</script>
